function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M145,217.14v73H96.87v-73l-7-13.19a136.45,136.45,0,0,1-41.2,15.87v70.36H.54V1.2H48.71V170a89.66,89.66,0,0,0,48.16-38V1.2H145V144.09a137.8,137.8,0,0,1-21.52,32.31Z",
  transform: "translate(132.18 -1.2)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M330.81,1.2V270.92a19.27,19.27,0,0,1-19.27,19.26h-106a19.26,19.26,0,0,1-19.26-19.26V1.2h48.16V242h48.16V1.2Z",
  transform: "translate(132.18 -1.2)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M516.58,20.47V144.09a137.7,137.7,0,0,1-21.52,32.31l21.52,40.74v73H468.42v-73l-7-13.19a136.25,136.25,0,0,1-41.2,15.87v70.36H372.09V1.2H497.31a19.47,19.47,0,0,1,4.35.51A19.27,19.27,0,0,1,516.58,20.47ZM420.25,170a89.62,89.62,0,0,0,48.17-38V49.36H420.25Z",
  transform: "translate(132.18 -1.2)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M577.13,1.2h106a19.26,19.26,0,0,1,19.26,19.27V270.92a19.26,19.26,0,0,1-19.26,19.26h-106a19.26,19.26,0,0,1-19.26-19.26V20.47A19.26,19.26,0,0,1,577.13,1.2Zm77.06,48.16H606V242h48.16Z",
  transform: "translate(132.18 -1.2)"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "133 -1.5 702 288.98",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.1c28c846.svg";
export { ForwardRef as ReactComponent };